export const CREATE_PROPERTY_UNIT_DOCUMENT = "CREATE_PROPERTY_UNIT_DOCUMENT";
export const FETCH_PROPERTY_UNIT_DOCUMENTS = "FETCH_PROPERTY_UNIT_DOCUMENTS";
export const FETCH_PROPERTY_UNIT_DOCUMENT = "FETCH_PROPERTY_UNIT_DOCUMENT";
export const EDIT_PROPERTY_UNIT_DOCUMENT = "EDIT_PROPERTY_UNIT_DOCUMENT";
export const DELETE_PROPERTY_UNIT_DOCUMENT = "DELETE_PROPERTY_UNIT_DOCUMENT";
